
export const sportsCategories = [
  {
    id: 1,
    name: '足球',
    icon: 'ri-football-fill',
    color: '#22c55e',
    liveCount: 156
  },
  {
    id: 2,
    name: '篮球',
    icon: 'ri-basketball-fill',
    color: '#f97316',
    liveCount: 89
  },
  {
    id: 3,
    name: '网球',
    icon: 'ri-tennis-ball-fill',
    color: '#eab308',
    liveCount: 45
  },
  {
    id: 4,
    name: '乒乓球',
    icon: 'ri-ping-pong-fill',
    color: '#ef4444',
    liveCount: 67
  },
  {
    id: 5,
    name: '羽毛球',
    icon: 'ri-t-shirt-2-fill',
    color: '#3b82f6',
    liveCount: 34
  },
  {
    id: 6,
    name: '排球',
    icon: 'ri-football-fill',
    color: '#8b5cf6',
    liveCount: 28
  }
];

export const liveMatches = [
  {
    id: 1,
    title: '皇家马德里 vs 巴塞罗那',
    category: '足球',
    league: '西甲',
    status: 'live',
    viewers: 125680,
    time: '65\'',
    date: '12-28',
    score: '1-2',
    thumbnail: 'https://readdy.ai/api/search-image?query=football%20match%20Real%20Madrid%20vs%20Barcelona%20in%20Santiago%20Bernabeu%20stadium%20with%20green%20grass%20field%20and%20crowded%20stadium%2C%20professional%20sports%20photography%2C%20high%20quality%20broadcast%20view&width=320&height=180&seq=live1&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
  },
  {
    id: 2,
    title: '湖人 vs 勇士',
    category: '篮球',
    league: 'NBA',
    status: 'live',
    viewers: 89432,
    time: '35:23',
    date: '12-28',
    score: '78-85',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20Lakers%20vs%20Warriors%20in%20modern%20arena%20with%20wooden%20court%20and%20bright%20stadium%20lights%2C%20professional%20sports%20broadcast%20angle&width=320&height=180&seq=live2&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
  },
  {
    id: 3,
    title: '德约科维奇 vs 纳达尔',
    category: '网球',
    league: 'ATP',
    status: 'live',
    viewers: 67890,
    time: '第3盘 2-1',
    date: '12-28',
    score: '6-4, 4-3',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20tennis%20match%20on%20clay%20court%20with%20two%20players%20competing%2C%20Roland%20Garros%20style%20stadium%20with%20red%20clay%20surface%20and%20crowded%20stands&width=320&height=180&seq=live3&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'
  },
  {
    id: 4,
    title: '中国女排 vs 巴西女排',
    category: '排球',
    league: '世界联赛',
    status: 'live',
    viewers: 45123,
    time: '第3局 18-15',
    date: '12-28',
    score: '1-0',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20volleyball%20match%20China%20vs%20Brazil%20womens%20team%20in%20indoor%20stadium%20with%20wooden%20floor%20and%20bright%20lights%2C%20volleyball%20net%20and%20players%20action&width=320&height=180&seq=live4&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4'
  },
  {
    id: 5,
    title: '马龙 vs 樊振东',
    category: '乒乓球',
    league: 'WTT冠军赛',
    status: 'live',
    viewers: 78654,
    time: '第5局 7-9',
    date: '12-28',
    score: '2-1',
    thumbnail: 'https://readdy.ai/api/search-image?query=table%20tennis%20championship%20match%20Ma%20Long%20vs%20Fan%20Zhendong%20with%20blue%20table%20and%20professional%20lighting%20in%20competition%20hall&width=320&height=180&seq=live5&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4'
  },
  {
    id: 6,
    title: '石宇奇 vs 安赛龙',
    category: '羽毛球',
    league: '全英公开赛',
    status: 'live',
    viewers: 56789,
    time: '第2局 19-17',
    date: '12-28',
    score: '1-0',
    thumbnail: 'https://readdy.ai/api/search-image?query=badminton%20championship%20match%20in%20professional%20indoor%20court%20with%20green%20floor%20and%20white%20lines%2C%20players%20competing%20intensely&width=320&height=180&seq=live6&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4'
  }
];

export const upcomingMatches = [
  {
    id: 7,
    title: '曼城 vs 利物浦',
    category: '足球',
    league: '英超',
    status: 'upcoming',
    viewers: 0,
    time: '今天 21:30',
    date: '12-28',
    thumbnail: 'https://readdy.ai/api/search-image?query=Premier%20League%20football%20stadium%20Manchester%20City%20vs%20Liverpool%20match%20preview%20with%20green%20pitch%20and%20modern%20stadium%20architecture&width=320&height=180&seq=upcoming1&orientation=landscape'
  },
  {
    id: 8,
    title: '中国 vs 日本',
    category: '乒乓球',
    league: '世界杯',
    status: 'upcoming',
    viewers: 0,
    time: '明天 19:00',
    date: '12-29',
    thumbnail: 'https://readdy.ai/api/search-image?query=table%20tennis%20championship%20venue%20with%20blue%20tables%20and%20professional%20lighting%20setup%20for%20international%20competition%20China%20vs%20Japan&width=320&height=180&seq=upcoming2&orientation=landscape'
  },
  {
    id: 9,
    title: '掘金 vs 太阳',
    category: '篮球',
    league: 'NBA',
    status: 'upcoming',
    viewers: 0,
    time: '明天 9:00',
    date: '12-29',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20arena%20Denver%20Nuggets%20vs%20Phoenix%20Suns%20game%20preview%20with%20basketball%20court%20and%20empty%20stadium%20before%20game&width=320&height=180&seq=upcoming3&orientation=landscape'
  },
  {
    id: 10,
    title: '阿尔卡拉斯 vs 辛纳',
    category: '网球',
    league: '法网',
    status: 'upcoming',
    viewers: 0,
    time: '明天 22:00',
    date: '12-29',
    thumbnail: 'https://readdy.ai/api/search-image?query=French%20Open%20tennis%20court%20with%20red%20clay%20surface%20Roland%20Garros%20stadium%20preparation%20for%20Alcaraz%20vs%20Sinner%20match&width=320&height=180&seq=upcoming4&orientation=landscape'
  },
  {
    id: 11,
    title: '意大利 vs 法国',
    category: '排球',
    league: '欧洲联赛',
    status: 'upcoming',
    viewers: 0,
    time: '后天 20:00',
    date: '12-30',
    thumbnail: 'https://readdy.ai/api/search-image?query=European%20volleyball%20championship%20venue%20Italy%20vs%20France%20with%20professional%20indoor%20court%20and%20spectator%20stands&width=320&height=180&seq=upcoming5&orientation=landscape'
  }
];

export const replayMatches = [
  {
    id: 12,
    title: '世界杯决赛：阿根廷 vs 法国',
    category: '足球',
    league: '世界杯',
    duration: '97分钟',
    views: 2560000,
    date: '12-18',
    thumbnail: 'https://readdy.ai/api/search-image?query=FIFA%20World%20Cup%20final%20match%20Argentina%20vs%20France%20in%20Qatar%20stadium%20with%20golden%20trophy%20and%20celebration%20atmosphere%2C%20historic%20football%20moment&width=320&height=180&seq=replay1&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
  },
  {
    id: 13,
    title: 'NBA总决赛G7：勇士 vs 凯尔特人',
    category: '篮球',
    league: 'NBA',
    duration: '48分钟',
    views: 1890000,
    date: '12-16',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20Finals%20Game%207%20Warriors%20vs%20Celtics%20in%20TD%20Garden%20arena%20with%20championship%20atmosphere%20and%20intense%20basketball%20action&width=320&height=180&seq=replay2&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
  },
  {
    id: 14,
    title: '温网决赛：费德勒 vs 德约科维奇',
    category: '网球',
    league: '温网',
    duration: '4小时57分钟',
    views: 987000,
    date: '12-14',
    thumbnail: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20final%20on%20grass%20court%20Centre%20Court%20with%20traditional%20white%20clothing%20and%20British%20tennis%20atmosphere&width=320&height=180&seq=replay3&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'
  },
  {
    id: 15,
    title: '奥运决赛：中国 vs 瑞典',
    category: '乒乓球',
    league: '奥运会',
    duration: '2小时35分钟',
    views: 1234000,
    date: '12-05',
    thumbnail: 'https://readdy.ai/api/search-image?query=Olympic%20table%20tennis%20final%20China%20vs%20Sweden%20with%20Olympic%20rings%20and%20gold%20medal%20ceremony%20atmosphere%20in%20Tokyo%20venue&width=320&height=180&seq=replay4&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4'
  },
  {
    id: 16,
    title: '全英决赛：陈雨菲 vs 马林',
    category: '羽毛球',
    league: '全英公开赛',
    duration: '1小时29分钟',
    views: 654000,
    date: '12-19',
    thumbnail: 'https://readdy.ai/api/search-image?query=All%20England%20badminton%20championship%20womens%20final%20Chen%20Yufei%20vs%20Carolina%20Marin%20in%20Birmingham%20arena%20with%20professional%20court&width=320&height=180&seq=replay5&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4'
  },
  {
    id: 17,
    title: '世锦赛决赛：中国 vs 巴西',
    category: '排球',
    league: '世界锦标赛',
    duration: '3小时12分钟',
    views: 876000,
    date: '12-15',
    thumbnail: 'https://readdy.ai/api/search-image?query=Volleyball%20World%20Championship%20final%20China%20vs%20Brazil%20with%20trophy%20presentation%20and%20celebration%20in%20modern%20indoor%20arena&width=320&height=180&seq=replay6&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4'
  },
  {
    id: 18,
    title: '欧冠决赛：皇马 vs 利物浦',
    category: '足球',
    league: '欧冠',
    duration: '2小时6分钟',
    views: 3200000,
    date: '12-10',
    thumbnail: 'https://readdy.ai/api/search-image?query=UEFA%20Champions%20League%20final%20Real%20Madrid%20vs%20Liverpool%20in%20modern%20stadium%20with%20trophy%20and%20celebration%20atmosphere&width=320&height=180&seq=replay7&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4'
  },
  {
    id: 19,
    title: 'F1阿布扎比大奖赛：汉密尔顿夺冠',
    category: 'F1',
    league: 'F1世界锦标赛',
    duration: '1小时58分钟',
    views: 1560000,
    date: '12-08',
    thumbnail: 'https://readdy.ai/api/search-image?query=Formula%201%20Abu%20Dhabi%20Grand%20Prix%20race%20with%20modern%20F1%20cars%20on%20track%20and%20championship%20celebration%20atmosphere&width=320&height=180&seq=replay8&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4'
  },
  {
    id: 20,
    title: '游泳世锦赛：张雨霏破世界纪录',
    category: '游泳',
    league: '世界游泳锦标赛',
    duration: '45分钟',
    views: 890000,
    date: '12-12',
    thumbnail: 'https://readdy.ai/api/search-image?query=Swimming%20world%20championship%20with%20crystal%20clear%20pool%20water%20and%20professional%20swimmer%20breaking%20world%20record%20celebration&width=320&height=180&seq=replay9&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4'
  },
  {
    id: 21,
    title: '体操世锦赛：全能决赛精彩集锦',
    category: '体操',
    league: '世界体操锦标赛',
    duration: '78分钟',
    views: 1120000,
    date: '12-06',
    thumbnail: 'https://readdy.ai/api/search-image?query=Gymnastics%20world%20championship%20with%20professional%20gymnast%20performing%20on%20apparatus%20in%20bright%20arena%20with%20judges%20and%20crowd&width=320&height=180&seq=replay10&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4'
  },
  {
    id: 22,
    title: '斯诺克世锦赛：奥沙利文完美147',
    category: '台球',
    league: '世界斯诺克锦标赛',
    duration: '35分钟',
    views: 756000,
    date: '12-20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Snooker%20world%20championship%20with%20green%20table%20and%20professional%20player%20making%20perfect%20147%20break%20with%20crowd%20cheering&width=320&height=180&seq=replay11&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4'
  },
  {
    id: 23,
    title: '田径世锦赛：博尔特百米飞人大战',
    category: '田径',
    league: '世界田径锦标赛',
    duration: '25分钟',
    views: 2100000,
    date: '12-07',
    thumbnail: 'https://readdy.ai/api/search-image?query=Athletics%20world%20championship%20100m%20sprint%20race%20with%20Usain%20Bolt%20crossing%20finish%20line%20in%20Olympic%20stadium%20with%20cheering%20crowd&width=320&height=180&seq=replay12&orientation=landscape',
    videoUrl: 'https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_2mb.mp4'
  },
  {
    id: 24,
    title: '拳击世界冠军赛：泰森vs霍利菲尔德',
    category: '拳击',
    league: '重量级冠军赛',
    duration: '1小时42分钟',
    views: 1680000,
    date: '12-13',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20boxing%20championship%20match%20with%20two%20heavyweight%20boxers%20in%20ring%20with%20bright%20arena%20lights%20and%20excited%20crowd&width=320&height=180&seq=replay13&orientation=landscape',
    videoUrl: 'https://filesamples.com/samples/video/mp4/SampleVideo_1280x720_5mb.mp4'
  },
  {
    id: 25,
    title: '高尔夫大师赛：伍兹复出夺冠',
    category: '高尔夫',
    league: '美国大师赛',
    duration: '4小时17分钟',
    views: 1340000,
    date: '12-11',
    thumbnail: 'https://readdy.ai/api/search-image?query=Golf%20Masters%20tournament%20with%20Tiger%20Woods%20celebrating%20victory%20on%20green%20course%20with%20trophy%20and%20cheering%20fans&width=320&height=180&seq=replay14&orientation=landscape',
    videoUrl: 'https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4'
  }
];

export const userStreams = [
  {
    id: 18,
    title: '业余足球联赛决赛',
    streamer: '足球爱好者小王',
    viewers: 234,
    category: '足球',
    isLive: true,
    thumbnail: 'https://readdy.ai/api/search-image?query=amateur%20football%20match%20on%20local%20grass%20field%20with%20casual%20players%20and%20small%20crowd%2C%20community%20sports%20atmosphere&width=320&height=180&seq=user1&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4'
  },
  {
    id: 19,
    title: '街头篮球挑战赛',
    streamer: '篮球达人',
    viewers: 567,
    category: '篮球',
    isLive: true,
    thumbnail: 'https://readdy.ai/api/search-image?query=street%20basketball%20court%20with%20urban%20background%20and%20players%20competing%20in%20streetball%20style%20game%2C%20outdoor%20sports%20setting&width=320&height=180&seq=user2&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
  },
  {
    id: 20,
    title: '社区乒乓球比赛',
    streamer: '乒乓球教练李师傅',
    viewers: 123,
    category: '乒乓球',
    isLive: false, // 未开播状态
    thumbnail: 'https://readdy.ai/api/search-image?query=community%20table%20tennis%20competition%20in%20local%20sports%20center%20with%20casual%20players%20and%20friendly%20atmosphere&width=320&height=180&seq=user3&orientation=landscape',
    videoUrl: null // 无视频源
  },
  {
    id: 21,
    title: '网球训练课直播',
    streamer: '网球教练Anna',
    viewers: 345,
    category: '网球',
    isLive: true,
    thumbnail: 'https://readdy.ai/api/search-image?query=tennis%20coaching%20session%20on%20outdoor%20court%20with%20instructor%20teaching%20techniques%20and%20students%20practicing&width=320&height=180&seq=user4&orientation=landscape',
    videoUrl: null // 直播中断状态
  },
  {
    id: 22,
    title: '羽毛球技巧教学',
    streamer: '羽毛球高手小刘',
    viewers: 189,
    category: '羽毛球',
    isLive: true,
    thumbnail: 'https://readdy.ai/api/search-image?query=badminton%20coaching%20in%20indoor%20court%20with%20instructor%20demonstrating%20techniques%20and%20proper%20form%20to%20students&width=320&height=180&seq=user5&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4'
  },
  {
    id: 23,
    title: '排球战术分析',
    streamer: '排球教练张教练',
    viewers: 267,
    category: '排球',
    isLive: false, // 未开播状态
    thumbnail: 'https://readdy.ai/api/search-image?query=volleyball%20tactics%20coaching%20session%20in%20gym%20with%20coach%20explaining%20strategies%20and%20team%20formations&width=320&height=180&seq=user6&orientation=landscape',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4'
  }
];

export const sportsNews = [
  {
    id: 1,
    title: 'NBA总决赛第七场激战，湖人队以惊险一分险胜夺冠',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20championship%20trophy%20with%20golden%20details%20and%20professional%20basketball%20court%20background%2C%20bright%20arena%20lighting%20and%20celebratory%20atmosphere%2C%20modern%20sports%20photography%20style%20with%20warm%20golden%20tones&width=200&height=120&seq=news1&orientation=landscape',
    publishTime: '2小时前',
    views: '15.2万',
    category: '篮球',
    summary: '在刚刚结束的NBA总决赛第七场比赛中，洛杉矶湖人队在主场以108-107的比分险胜...'
  },
  {
    id: 2,
    title: '英超转会窗口重磅消息：曼城正式签下巴西中场新星',
    image: 'https://readdy.ai/api/search-image?query=Premier%20League%20soccer%20transfer%20announcement%20with%20Manchester%20City%20blue%20colors%2C%20professional%20soccer%20player%20in%20blue%20jersey%2C%20modern%20football%20stadium%20background%20with%20bright%20green%20grass%20field&width=200&height=120&seq=news2&orientation=landscape',
    publishTime: '4小时前',
    views: '8.7万',
    category: '足球',
    summary: '曼彻斯特城足球俱乐部今日正式宣布，以创纪录的转会费签下巴西国家队中场核心球员...'
  },
  {
    id: 3,
    title: '中国女排世界杯夺冠，郎平教练赛后激动落泪',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20womens%20volleyball%20team%20celebrating%20victory%20with%20golden%20trophy%2C%20red%20team%20uniforms%2C%20volleyball%20court%20with%20bright%20lighting%2C%20emotional%20celebration%20moment%20with%20coach%20and%20players&width=200&height=120&seq=news3&orientation=landscape',
    publishTime: '6小时前',
    views: '25.8万',
    category: '排球',
    summary: '在今晚进行的女排世界杯决赛中，中国女排以3-1战胜巴西队，成功卫冕世界杯冠军...'
  },
  {
    id: 4,
    title: 'F1赛季收官战：汉密尔顿职业生涯第100个分站冠军',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20crossing%20finish%20line%20with%20checkered%20flag%2C%20professional%20race%20track%20with%20modern%20F1%20vehicle%2C%20bright%20racing%20colors%20and%20speed%20motion%20blur%20effect&width=200&height=120&seq=news4&orientation=landscape',
    publishTime: '8小时前',
    views: '12.3万',
    category: 'F1',
    summary: '在阿布扎比大奖赛中，英国车手刘易斯·汉密尔顿驾驶梅赛德斯赛车夺得冠军...'
  },
  {
    id: 5,
    title: '东京奥运会游泳项目：中国队创造多项新纪录',
    image: 'https://readdy.ai/api/search-image?query=Olympic%20swimming%20pool%20with%20crystal%20clear%20blue%20water%2C%20professional%20swimmers%20in%20racing%20position%2C%20modern%20Olympic%20aquatic%20center%20with%20bright%20lighting%20and%20Chinese%20flag%20colors&width=200&height=120&seq=news5&orientation=landscape',
    publishTime: '10小时前',
    views: '18.9万',
    category: '游泳',
    summary: '在东京奥运会游泳比赛中，中国游泳队表现出色，在多个项目中打破世界纪录...'
  },
  {
    id: 6,
    title: 'CBA季后赛：广东宏远队成功卫冕总冠军',
    image: 'https://readdy.ai/api/search-image?query=CBA%20basketball%20championship%20celebration%20with%20red%20and%20white%20team%20colors%2C%20professional%20basketball%20arena%20with%20bright%20court%20lighting%2C%20trophy%20presentation%20ceremony%20atmosphere&width=200&height=120&seq=news6&orientation=landscape',
    publishTime: '12小时前',
    views: '9.4万',
    category: '篮球',
    summary: '在CBA总决赛第六场比赛中，广东宏远队主场以95-88战胜辽宁队，成功卫冕...'
  },
  {
    id: 7,
    title: '网球大满贯：德约科维奇第21次夺得大满贯冠军',
    image: 'https://readdy.ai/api/search-image?query=Tennis%20grand%20slam%20trophy%20with%20professional%20tennis%20court%20background%2C%20bright%20green%20court%20surface%20with%20white%20lines%2C%20modern%20tennis%20stadium%20atmosphere%20with%20championship%20celebration&width=200&height=120&seq=news7&orientation=landscape',
    publishTime: '1天前',
    views: '14.6万',
    category: '网球',
    summary: '在温布尔登网球锦标赛男单决赛中，塞尔维亚选手德约科维奇成功夺冠...'
  },
  {
    id: 8,
    title: '高尔夫大师赛：泰格·伍兹重返巅峰夺得冠军',
    image: 'https://readdy.ai/api/search-image?query=Golf%20Masters%20tournament%20with%20green%20course%20and%20professional%20golfer%20celebrating%20victory%2C%20bright%20sunny%20golf%20course%20with%20perfectly%20manicured%20grass%2C%20championship%20atmosphere%20with%20golden%20trophy&width=200&height=120&seq=news8&orientation=landscape',
    publishTime: '1天前',
    views: '7.2万',
    category: '高尔夫',
    summary: '在美国大师赛最后一轮比赛中，泰格·伍兹凭借出色发挥成功夺冠...'
  },
  {
    id: 9,
    title: 'LOL世界赛总决赛：中国战队夺得冠军',
    image: 'https://readdy.ai/api/search-image?query=Esports%20tournament%20arena%20with%20professional%20gaming%20setup%2C%20bright%20LED%20screens%20and%20enthusiastic%20crowd%2C%20modern%20gaming%20championship%20atmosphere%20with%20trophy%20presentation&width=200&height=120&seq=news9&orientation=landscape',
    publishTime: '6小时前',
    views: '32.5万',
    category: '电竞',
    summary: '在刚刚结束的英雄联盟世界锦标赛总决赛中，中国战队以3-1的比分战胜韩国队...'
  },
  {
    id: 10,
    title: 'FIFA电竞世界杯：中国选手首次夺冠',
    image: 'https://readdy.ai/api/search-image?query=FIFA%20esports%20championship%20with%20virtual%20football%20gameplay%20on%20screen%2C%20professional%20gaming%20setup%20with%20controller%2C%20bright%20tournament%20lighting%20and%20celebration%20atmosphere&width=200&height=120&seq=news10&orientation=landscape',
    publishTime: '1天前',
    views: '18.7万',
    category: '电竞',
    summary: 'FIFA电竞世界杯总决赛中，来自中国的职业选手小明成功夺冠，创造历史...'
  },
  {
    id: 11,
    title: 'CS:GO Major赛事：亚洲战队强势崛起',
    image: 'https://readdy.ai/api/search-image?query=Counter%20Strike%20esports%20tournament%20with%20professional%20gaming%20arena%2C%20bright%20stage%20lighting%20and%20competitive%20gaming%20atmosphere%2C%20modern%20esports%20championship%20setup&width=200&height=120&seq=news11&orientation=landscape',
    publishTime: '2天前',
    views: '14.2万',
    category: '电竞',
    summary: '在最新一期的CS:GO Major锦标赛中，来自亚洲的多支战队表现出色...'
  },
  {
    id: 12,
    title: '王者荣耀职业联赛：新赛季即将开启',
    image: 'https://readdy.ai/api/search-image?query=Mobile%20esports%20tournament%20arena%20with%20smartphone%20gaming%20setup%2C%20colorful%20MOBA%20game%20interface%2C%20professional%20mobile%20gaming%20championship%20atmosphere%20with%20bright%20lighting&width=200&height=120&seq=news12&orientation=landscape',
    publishTime: '3天前',
    views: '28.3万',
    category: '电竞',
    summary: '王者荣耀职业联赛新赛季将于下周正式开启，16支职业战队将展开激烈角逐...'
  }
];

// 添加游戏分类标签数据
export const gameCategories = [
  '篮球游戏', '足球游戏', '网球游戏', '排球游戏', '赛车游戏', 
  '体感游戏', '高尔夫游戏', 'MOBA游戏', 'FPS游戏', '策略游戏', '模拟游戏'
];

export const userProfiles = [
  {
    id: 1,
    username: '足球爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20football%20player%20with%20green%20jersey%20and%20blue%20shorts%2C%20standing%20on%20green%20grass%20field%20with%20yellow%20ball%2C%20bright%20stadium%20lighting%20and%20cheering%20crowd&width=100&height=100&seq=profile1&orientation=portrait',
    bio: '热爱足球运动，关注国内外顶级赛事，喜欢分析战术和球员表现',
    followers: 1234,
    following: 567,
    posts: 89,
    verified: true
  },
  {
    id: 2,
    username: '篮球达人',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20basketball%20player%20with%20orange%20jersey%20and%20black%20shorts%2C%20standing%20on%20wooden%20court%20with%20white%20lines%2C%20bright%20arena%20lighting%20and%20cheering%20crowd&width=100&height=100&seq=profile2&orientation=portrait',
    bio: '篮球爱好者，关注NBA、CBA等热门赛事，喜欢分析球员技术和战术',
    followers: 5678,
    following: 1234,
    posts: 345,
    verified: false
  },
  {
    id: 3,
    username: '乒乓球教练李师傅',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20table%20tennis%20coach%20with%20blue%20shirt%20and%20black%20shorts%2C%20standing%20on%20indoor%20court%20with%20green%20floor%20and%20white%20lines%2C%20bright%20lighting%20and%20enthusiastic%20students&width=100&height=100&seq=profile3&orientation=portrait',
    bio: '乒乓球教练，拥有多年教学经验，擅长分析球员技术和战术',
    followers: 2345,
    following: 890,
    posts: 123,
    verified: true
  },
  {
    id: 4,
    username: '网球教练Anna',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20tennis%20coach%20with%20white%20shirt%20and%20black%20shorts%2C%20standing%20on%20outdoor%20court%20with%20yellow%20ball%20and%20bright%20sunlight%2C%20cheering%20crowd%20and%20enthusiastic%20students&width=100&height=100&seq=profile4&orientation=portrait',
    bio: '网球教练，拥有多年教学经验，擅长分析球员技术和战术',
    followers: 8901,
    following: 2345,
    posts: 345,
    verified: false
  },
  {
    id: 5,
    username: '羽毛球高手小刘',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20badminton%20player%20with%20green%20jersey%20and%20black%20shorts%2C%20standing%20on%20indoor%20court%20with%20green%20floor%20and%20white%20lines%2C%20bright%20lighting%20and%20enthusiastic%20crowd&width=100&height=100&seq=profile5&orientation=portrait',
    bio: '羽毛球高手，拥有多年比赛经验，擅长分析球员技术和战术',
    followers: 5678,
    following: 1234,
    posts: 189,
    verified: true
  },
  {
    id: 6,
    username: '排球教练张教练',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20volleyball%20coach%20with%20blue%20shirt%20and%20black%20shorts%2C%20standing%20on%20indoor%20court%20with%20wooden%20floor%20and%20bright%20lighting%2C%20enthusiastic%20students%20and%20celebration%20atmosphere&width=100&height=100&seq=profile6&orientation=portrait',
    bio: '排球教练，拥有多年教学经验，擅长分析球员技术和战术',
    followers: 2345,
    following: 890,
    posts: 267,
    verified: false
  }
];
